
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userData"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserInput"}}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"mutation"},"name":{"kind":"Name","value":"bulkCreateUsersInCompany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userData"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotFoundErrorFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnexpectedLengthErrorFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnexpectedSymbolErrorFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UniqueValueErrorFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmptyValueErrorFragment"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":707}};
    doc.loc.source = {"body":"#import './fragment-user-fields.graphql'\n#import '@/queries/errors/not-found-error-fragment.graphql'\n#import '@/queries/errors/unexpected-length-error-fragment.graphql'\n#import '@/queries/errors/unexpected-symbol-error-fragment.graphql'\n#import '@/queries/errors/unique-value-error-fragment.graphql'\n#import '@/queries/errors/empty-value-error-fragment.graphql'\n\nmutation ($userData: [CreateUserInput!]!) {\n\tmutation: bulkCreateUsersInCompany(userData: $userData) {\n\t\tsuccess\n\t\tusers {\n\t\t\t...UserFields\n\t\t}\n\t\terror {\n\t\t\ttype: __typename\n\t\t\t...NotFoundErrorFragment\n\t\t\t...UnexpectedLengthErrorFragment\n\t\t\t...UnexpectedSymbolErrorFragment\n\t\t\t...UniqueValueErrorFragment\n\t\t\t...EmptyValueErrorFragment\n\t\t}\n\t}\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./fragment-user-fields.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('@/queries/errors/not-found-error-fragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('@/queries/errors/unexpected-length-error-fragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('@/queries/errors/unexpected-symbol-error-fragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('@/queries/errors/unique-value-error-fragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('@/queries/errors/empty-value-error-fragment.graphql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
